export default __webpack_public_path__ + "static/media/tomato.239bd661.png";